export default "__VITE_ASSET__CMy4ic4H__"